import React, { FC } from 'react';
import Link from 'next/link';
import { cn } from 'helpers/utils/classnames';
import { siteIntegrityGroup } from './types';

interface Props {
  siteIntegrityGroup: siteIntegrityGroup[];
  isCheckoutPage?: boolean;
}

const FooterBottom: FC<Props> = ({ siteIntegrityGroup, isCheckoutPage = false }) => {
  return (
    <div
      className={cn(
        'flex flex-col items-center px-[15px] py-3 lg:mx-auto lg:max-w-[var(--page-max-width)] lg:flex-row lg:justify-between lg:px-4 lg:py-5',
        { 'border-0 border-primary-gray/15 lg:border-t-[1px]': !isCheckoutPage },
      )}
    >
      <div className="flex w-full flex-wrap items-center justify-center text-nowrap border-t border-primary-gray/15 lg:w-auto lg:border-0">
        {siteIntegrityGroup &&
          siteIntegrityGroup.map((siteIntegrity, index) => (
            <Link
              href={siteIntegrity?.link || ''}
              title={siteIntegrity?.title}
              aria-label={siteIntegrity?.title}
              className="flex items-center text-xs font-normal leading-9 after:mr-2 after:inline-block after:h-[12px] after:w-px after:bg-black after:content-[''] after:last:hidden hover:underline"
              data-testid="site-integrity-group-link"
              key={'site-integrity-group-link-' + siteIntegrity.title + '-' + index}
            >
              <h3 className="mr-2">{siteIntegrity?.title}</h3>
            </Link>
          ))}
      </div>
      <h4 className="mt-2 flex text-center text-xs font-normal lg:mt-0">
        © {new Date().getFullYear()} Shades of Light All Rights Reserved
      </h4>
    </div>
  );
};

export default FooterBottom;
